import { render } from "./aaj-page.vue?vue&type=template&id=d0d06c98&scoped=true"
import script from "./aaj-page.vue?vue&type=script&lang=js"
export * from "./aaj-page.vue?vue&type=script&lang=js"

import "./aaj-page.vue?vue&type=style&index=0&id=d0d06c98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0d06c98"]])

export default __exports__